var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col" }, [
    _c(
      "div",
      {
        staticClass:
          "py-4 px-6 flex items-center justify-between border-b border-slate-400"
      },
      [
        _c("BlTextSubtitle2", {
          staticClass: "text-slate-700",
          attrs: { text: "Table of contents" }
        }),
        _vm._v(" "),
        _c("BlIcon", {
          staticClass: "h-6 w-6",
          attrs: { icon: "close", clickable: "" },
          on: {
            clicked: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    !_vm.tableOfContents.length
      ? _c(
          "div",
          { staticClass: "pt-4 pb-8 px-6 text-center" },
          [
            _vm.report.status === "unpublished"
              ? _c("BlTextBody2", {
                  staticClass: "text-slate-700",
                  attrs: { text: "Add heading to create table of contents." }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.report.status === "published"
              ? _c("BlTextBody2", {
                  staticClass: "text-slate-700",
                  attrs: {
                    text: "This report doesn't have a table of contents."
                  }
                })
              : _vm._e()
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "py-4 pl-4 pr-6" },
          _vm._l(_vm.tableOfContents, function(content) {
            return _c(
              "div",
              {
                key: content.id,
                staticClass:
                  "h-8 w-104 pl-2 flex items-center border-l-2 cursor-pointer truncate",
                class: {
                  "border-transparent": _vm.sectionFocusedId !== content.id,
                  "bg-slate-200 border-light-purple":
                    _vm.sectionFocusedId == content.id
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("change-focus-id", content.id)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "h-5 truncate",
                    class: {
                      "pl-5": content.kind === "heading2",
                      "pl-10": content.kind === "heading3"
                    }
                  },
                  [
                    _c("BlTextBody2", {
                      staticClass: "truncate",
                      class: {
                        "text-light-purple font-semibold":
                          _vm.sectionFocusedId == content.id
                      },
                      attrs: { text: content.data }
                    })
                  ],
                  1
                )
              ]
            )
          }),
          0
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12d61d44", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12d61d44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/helper/TableOfContents.vue
// module id = null
// module chunks = 